import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import commonFormMeta from '@Shared/components/form/commonFormMeta';

export interface ICardUpdateMeta{
  bank: FormInputMeta,
  pan: FormInputMeta,
  sequence: FormInputMeta,
  maximumThresholdForOfflineTransactions: FormInputMeta,
  minimumThresholdForConsecutiveTransactions: FormInputMeta,
  minimumThresholdForConsecutiveTransactionsOutsideIssuingCountry: FormInputMeta,
  maximumThresholdForInternationalTransactions: FormInputMeta,
  minimumThresholdAmountForLocalConsecutiveOfflineTransactions: FormInputMeta,
  upperThresholdAmountForConsecutiveLocalOfflineTransactions: FormInputMeta,
  upperThresholdAmountForConsecutiveLocalOfflineTransactionsSecondaryCurrency: FormInputMeta,

  schema: any,
}

const CardUpdateMeta: ICardUpdateMeta= {} as ICardUpdateMeta;

CardUpdateMeta.bank = commonFormMeta.bank;

CardUpdateMeta.pan = {
  name: 'pan',
  type: 'text',
  label: 'PAN',
  placeholder: '',
  validation: yup.string().required(),
};
CardUpdateMeta.sequence = {
  name: 'sequence',
  type: 'text',
  label: 'Sequence',
  placeholder: '',
  validation: yup.string().required(),
};

CardUpdateMeta.maximumThresholdForOfflineTransactions = {
  name: 'maximumThresholdForOfflineTransactions',
  type: 'text',
  label: 'Seuil maximum des transactions offline',
  placeholder: '',
  validation: yup.string().required(),
};
CardUpdateMeta.minimumThresholdForConsecutiveTransactions = {
  name: 'minimumThresholdForConsecutiveTransactions',
  type: 'text',
  label: 'Seuil minimum des transactions consecutives',
  placeholder: '',
  validation: yup.string().required(),
};
CardUpdateMeta.minimumThresholdForConsecutiveTransactions = {
  name: 'minimumThresholdForConsecutiveTransactions',
  type: 'text',
  label: 'Seuil maximum des transactions offline',
  placeholder: '',
  validation: yup.string().required(),
};
CardUpdateMeta.minimumThresholdForConsecutiveTransactionsOutsideIssuingCountry = {
  name: 'minimumThresholdForConsecutiveTransactionsOutsideIssuingCountry',
  type: 'text',
  label: 'Seuil minimum des transactions consecutives offline hors pays emetteur',
  placeholder: '',
  validation: yup.string().required(),
};
CardUpdateMeta.maximumThresholdForInternationalTransactions = {
  name: 'maximumThresholdForInternationalTransactions',
  type: 'text',
  label: 'Seuil maximum des transactions internationales',
  placeholder: '',
  validation: yup.string().required(),
};
CardUpdateMeta.minimumThresholdAmountForLocalConsecutiveOfflineTransactions = {
  name: 'minimumThresholdAmountForLocalConsecutiveOfflineTransactions',
  type: 'text',
  label: 'Le montant seuil minimum des transactions offline local consecutives',
  placeholder: '',
  validation: yup.string().required(),
};
CardUpdateMeta.upperThresholdAmountForConsecutiveLocalOfflineTransactions = {
  name: 'upperThresholdAmountForConsecutiveLocalOfflineTransactions',
  type: 'text',
  label: 'Le montant seuil superieur des transactions offline local consecutives',
  placeholder: '',
  validation: yup.string().required(),
};
CardUpdateMeta.upperThresholdAmountForConsecutiveLocalOfflineTransactionsSecondaryCurrency = {
  name: 'upperThresholdAmountForConsecutiveLocalOfflineTransactionsSecondaryCurrency',
  type: 'text',
  label: 'Le montant seuil superieur des transactions offline local consecutives (Devise secondaire)',
  placeholder: '',
  validation: yup.string().required(),
};


const validationSchema: any = {};

for (let fieldname in CardUpdateMeta) {
  validationSchema[fieldname] = (CardUpdateMeta as any)[fieldname].validation;
}

CardUpdateMeta.schema = yup.object().shape(validationSchema);

export default CardUpdateMeta;

